
import { authHeader } from '../helpers';
import store from '@/store';

const endpointLookup = {
  art_forms: 'art_form',
  art_media: 'art_medium',
  art_styles: 'art_style',
  art_subjects: 'art_subject',
  shipping_methods: 'shipping_method',
};

export const apiService = {
  scheduleRentalReturn,
  cancelRental,
  resumeRental,
  keepRental,
  getAddresses,
  lovePiece,
  unlovePiece,
  getLovedArt,
  getArt,
  getPiece,
  getArtist,
  getArtists,
  wasteMyTime,
  reportFault,
  getResource,
  addOrder,
  getOrders,
  getOrder,
  cancelOrder,
  getRental,
  getRentals,
  getQuote,
  getDiscount,
  getHelpTopics,
  getHelpArticles,
  contact,
};
// Item functions
function getAddresses() {
  return fetch('https://ams3.digitaloceanspaces.com/wall.res/resources/addresses.json').then(handleResponse);
}
function lovePiece(customerId, artId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/customer/${customerId}/love/${artId}?track=true`, requestOptions).then(handleResponse);
}
function unlovePiece(customerId, artId) {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/customer/${customerId}/love/${artId}`, requestOptions).then(handleResponse);
}
function getLovedArt(customerId, filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/customer/${customerId}/love?limit=${filter.limit || ''}&offset=${filter.offset || ''}`, requestOptions).then(handleResponse);
}
function getArt(filter) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  let statusString = '';
  if (filter.status) {
    statusString = filter.status.join('&status[]=');
  }
  return fetch(`
  ${process.env.ROOT_API}/art?form=${filter.form || ''}&medium=${filter.medium || ''}&style=${filter.style || ''}&subject=${filter.subject || ''}&artist_id=${filter.artist_id || ''}&limit=${filter.limit || ''}&offset=${filter.offset || ''}&is_test=${filter.is_test || false}${statusString ? `&status[]=${statusString}` : ''}&track=true`,
  requestOptions).then(handleResponse);
}
function getPiece(pieceId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/art/${pieceId}?track=true`, requestOptions).then(handleResponse);
}
function getArtist(artistId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist/${artistId}`, requestOptions).then(handleResponse);
}
function getArtists(filter) {
  let filterString = '';
  if (filter) {
    filterString += '?';
    const keys = Object.keys(filter);
    keys.forEach((key) => {
      // Handle array filters
      if (filter[key].length > 1) {
        filterString += `${key}[]=${filter[key].join(`&${key}[]=`)}`;
      } else {
        filterString += `&${key}=${filter[key]}`;
      }
    });
  }
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/artist${filterString}`, requestOptions).then(handleResponse);
}
// function getArtists(filter) {
//   const requestOptions = {
//     method: 'GET',
//     headers: { ...authHeader(), 'Content-Type': 'application/json' },
//   };
//   let statusString = '';
//   if (filter.status) {
//     statusString = filter.status.join('&status[]=');
//   }
//   return fetch(`${process.env.ROOT_API}/artist${statusString ? `?status[]=${statusString}` : ''}`, requestOptions).then(handleResponse);
// }
function getOrder(orderId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/order/${orderId}`, requestOptions).then(handleResponse);
}
function getOrders() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/order`, requestOptions).then(handleResponse);
}
function getRental(rentalId) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}`, requestOptions).then(handleResponse);
}
function getRentals() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental`, requestOptions).then(handleResponse);
}
async function scheduleRentalReturn(form, id) {
  const requestOptions = {
    method: 'PATCH',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/rental/${id}`, requestOptions).then(handleResponse);
}
async function cancelRental(rentalId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}/cancel`, requestOptions).then(handleResponse);
}
async function resumeRental(rentalId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}/resume`, requestOptions).then(handleResponse);
}
async function keepRental(rentalId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/rental/${rentalId}/keep`, requestOptions).then(handleResponse);
}
async function getQuote(items, customerId, orderType) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ items, customer_id: customerId }),
  };
  return fetch(`${process.env.ROOT_API}/customer/${customerId}/quote/${orderType}`, requestOptions).then(handleResponse);
}
function getDiscount(productId, customerId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ product_id: productId, customer_id: customerId }),
  };
  return fetch(`${process.env.ROOT_API}/art/discount`, requestOptions).then(handleResponse);
}
async function contact(form) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(form),
  };
  return fetch(`${process.env.ROOT_API}/contact`, requestOptions).then(handleResponse);
}
function wasteMyTime() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000);
  });
}
async function reportFault(error) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(error),
  };
  return fetch(`${process.env.ROOT_API}/staff/fault`, requestOptions).then(handleResponse);
}
function getResource(resource) {
  const requestOptions = {
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const paramString = `${process.env.ROOT_API}/resource/${endpointLookup[resource] || resource}`;
  return fetch(paramString, requestOptions).then(handleResponse);
}
function getHelpTopics() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/help/topic`, requestOptions).then(handleResponse);
}
function getHelpArticles(topic) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/help/article?topic_id=${topic}`, requestOptions).then(handleResponse);
}
async function addOrder(customerTotal, quoteId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ quote_id: quoteId, customer_total: customerTotal }),
  };
  return fetch(`${process.env.ROOT_API}/order`, requestOptions).then(handleResponse);
}
async function cancelOrder(orderId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
  };
  return fetch(`${process.env.ROOT_API}/order/${orderId}/cancel`, requestOptions).then(handleResponse);
}
// Helper Functions
function handleResponse(response) {
  return response.text().then((text) => {
    // const content = text && JSON.parse(text);
    if (!response.ok) {
      // Notify admin of issue
      // reportFault({ url: response.url, message: response.statusText });
      // auto logout if 401 response returned from api
      if (response.status === 401) {
        // INVALID USER GET HIM THE HELL OUT OF HERE!
        store.commit('account/logout');
        location.reload(true);
      }
      console.log(response);
      const error = (content && content.message) || response.statusText;
      return Promise.reject(error);
    }
    const content = text && JSON.parse(text);
    return Promise.resolve(content);
  });
}



// WEBPACK FOOTER //
// ./src/services/api.service.js